import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import style from "../../../report-depot/tableIsData.module.css";
import CustomTable from "../../../../../../component/table/CustomTable";
import { Table } from "antd";

const TableOrderReportWithData = (props) => {
  const { data } = props;

  const [datas, setDatas] = useState([]);

  const { t } = useTranslation();

  const ListColumn = useMemo(() => {
    const list = data?.headers?.map((el, idx) => {
      return {
        title: (
          <span className="font-roboto text-lg text-[#222222] font-medium">
            {t(el)}
          </span>
        ),
        dataIndex: `${idx}`,
        key: `${idx}`,
      };
    });
    return list;
  }, [data?.headers, t]);

  const datas2 = useMemo(() => {
    const listData2 = [
      {
        name: (
          <span className="font-roboto text-lg text-[#222222]">{"tessss"}</span>
        ),
        depot: (
          <span className="font-roboto text-lg text-[#222222]">{"osks"}</span>
        ),
      },
    ];
    return listData2;
  }, []);

  useEffect(() => {
    let listData = [];
    let dat = data?.data;

    for (let i = 0; i < dat.length; i++) {
      const element = dat[i];
      let datas2 = {};
      for (let j = 0; j < element.length; j++) {
        const element2 = element[j];
        datas2[`${j}`] = (
          <span className="font-roboto text-lg text-[#222222]">
            {element2?.value}
          </span>
        );
      }
      listData.push(datas2);
    }
    setDatas(listData);
  }, [data?.data]);

  return (
    <>
      <div className={style.tableContainer}>
        <CustomTable
          columns={ListColumn}
          data={datas}
          scroll={{ x: 5000, y: 500 }}
          isnotPaging={true}
          summary={() => (
            <Table.Summary fixed className="bg-red-200">
              <Table.Summary.Row className="bg-[#F7D1D2] font-roboto font-medium text-lg text-[#CF0000]">
                {data?.grand_total[0]?.map((el, idx) => {
                  return (
                    <>
                      <Table.Summary.Cell index={idx}>
                        {el?.value}
                      </Table.Summary.Cell>
                    </>
                  );
                })}
              </Table.Summary.Row>
            </Table.Summary>
          )}
        />
      </div>
    </>
  );
};

export default TableOrderReportWithData;
